import { useFlags } from "launchdarkly-react-client-sdk";
import { useAppSelector } from "redux/hooks";
import { selectClientLensSBREnabled } from "redux/slices/clientLens";

export function useShowSBR(): boolean {
  const { sbr } = useFlags();
  const sbrEnabled = useAppSelector(selectClientLensSBREnabled);
  const showSbr = sbrEnabled || sbr;

  return showSbr;
}
